export function isInt(value?: number | string) {
  if (typeof value === 'undefined') {
    return false;
  }

  const er = /^-?[0-9]+$/;
  return er.test(value?.toString());
}
